/* eslint-disable */
import { StyleSheet } from 'react-native'
import { ApplicationStyles } from '../../Themes/'
import { Platform } from 'react-native'
import { ifIPhoneX } from '../../Lib/utils';

  export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: { backgroundColor: '#5D6278', opacity: 0.9, flex: 1, flexDirection: 'column' },
  closeIconView: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 44,
    marginTop: Platform.OS == 'ios' ? ifIPhoneX(31, 20) : 0, // 44
    marginLeft: 0,
    marginRight: 0,
  },
  closeIcon: {
    width: 50,
    height: 50,
   alignItems : 'center',
   justifyContent: 'center',
  
  },
  menuIcon: {
    color: 'white', fontWeight: 'bold', fontSize: 30, alignSelf: 'center'
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingBottom: 10,
    paddingTop: 10
  }
})
